import { ChangeDetectorRef, Component, Inject, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, interval } from 'rxjs';

import { UtilityService } from 'src/app/core/services/utility.service';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { RegularExpressions } from '../../../../../core/constants/regular-expressions';
import { ApiNotificationService } from '../../../../../core/services/api-notification.service';
import { ModalTitleComponent } from '../../../../../shared/global/modal-title/modal-title.component';

@Component({
  selector: 'add-user-mobile',
  templateUrl: './add-user-mobile-dialog.component.html',
  styleUrls: ['./add-user-mobile-dialog.component.scss'],
  imports: [BaseIndexModule, ModalTitleComponent, ReactiveFormsModule],
})
export class AddUserMobileDialogComponent {
  //#region properties
  UtilityService = inject(UtilityService);

  mobile: string;
  protected onDestroy$ = new Subject<void>();
  source$ = interval(1000);
  loading: boolean;
  form: FormGroup;

  //#endregion

  constructor(
    public apiNotificationService: ApiNotificationService,
    private cd: ChangeDetectorRef,
    private dialogRef: MatDialogRef<AddUserMobileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      mobile: new FormControl(
        '',
        Validators.pattern(
          RegularExpressions.mobileNumberPrefixTo98EnglishAndPersian
        )
      ),
    });
  }

  onClose(mobile?: string) {
    this.dialogRef.close(
      mobile ? this.UtilityService.getTextWithEnglishNumber(this.mobile) : false
    );
    this.unSubs();
  }

  unSubs() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
